<template>
  <div class="home">
    <div class="slide-one">
      <div class="title-warp">
        <div class="title">买货车 换新车 租货车</div>
        <div class="title">就上货拉拉</div>
        <div class="send">
          <input
            type="text"
            v-model="ruleForm.mobile"
            placeholder="请输入您的手机号"
          />
          <div @click.stop="showDialog()">立即领取租购车优惠</div>
        </div>
      </div>
    </div>
    <div class="content-center" style="padding: 40px 0 80px">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/card-1.png" alt="" />
            <div class="title">包上牌</div>
            <div class="p">轻松上牌，快速上路，提车就赚钱</div>
          </div></el-col
        >
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/card-2.png" alt="" />
            <div class="title">提车快</div>
            <div class="p">大量现车不用等，一天就可 开新车</div>
          </div></el-col
        >
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/card-3.png" alt="" />
            <div class="title">送豪礼</div>
            <div class="p">限量豪礼等你来</div>
          </div></el-col
        >
      </el-row>
    </div>
    <div class="content-center">
      <div class="title-box">
        <div class="title">拉拉买车是什么</div>
      </div>
      <div class="slide-two"></div>
    </div>

    <div class="content-center">
      <div class="title-box">
        <div class="title">拉拉买车有什么</div>
      </div>
      <div class="slide-three"></div>
    </div>

    <div class="">
      <div class="slide-four">
        <div style="overflow: hidden">
          <div class="title-box">
            <div class="title">拉拉买车，货拉拉旗下一站式货车服务平台</div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-center">
      <div class="title-box">
        <div class="title">拉拉买车为客户持续提供价值与服务</div>
      </div>
      <div class="slide-five"></div>
    </div>

    <div class="content-center">
      <div class="title-box">
        <div class="title">拉拉买车与合作伙伴实现互利共赢</div>
      </div>
      <div class="slide-six"></div>
    </div>

    <!-- 弹窗 -->
    <div
      :class="dialogVisible ? 'dialog-wrap-show dialog-wrap' : 'dialog-wrap'"
    >
      <div class="dialog-mask"></div>
      <div class="dialog-form">
        <div class="dialog-close" @click.stop="closeDialog"></div>
        <p>
          <input
            type="text"
            v-model="ruleForm.name"
            placeholder="请问怎么称呼您(可选)"
          />
        </p>
        <p>
          <input
            type="number"
            v-model="ruleForm.mobile"
            placeholder="请输入您的手机号码"
          />
        </p>
        <a
          href="javascript:;"
          style="background-color:#f16622;cursor:pointer; "
          @click.stop="submitForm"
          >立即预约</a
        >
      </div>
    </div>
  </div>
</template>
 
<script>
import axios from 'axios';
export default {
  name: "Home",
  data () {
    return {
      dialogVisible: false,
      ruleForm: {
        name: '',
        mobile: '',
      }
    };
  },
  methods: {
    showDialog () {
      this.dialogVisible = true
    },
    checkMobile () {
      if(!this.ruleForm.mobile){
        this.$message.error('请输入手机号');
        return false;
      }else if (!/^1[3|4|5|6|7|8|9]\d{9}$/.test(this.ruleForm.mobile)) {
        this.$message.error('您的手机号码输入有误！');
        return false
      }
      return true;
    },
    getEnv(){
      if(location.host.indexOf('localhost') > -1 || location.host.indexOf('www-stg') > -1){
        return 'https://oms-stg.huolala.cn'
      }
      if(location.host.indexOf('www-pre') > -1){
        return 'https://oms-pre.huolala.cn'
      }
      if(location.host === 'www.huolalazuche.cn'){
        return 'https://oms.huolala.cn'
      }
    },
    async submitForm () {
      if(!this.checkMobile()){
        return ;
      }
      const { mobile, name } = this.ruleForm;
      const url = this.getEnv()+'/api/sale/scExInter/insertSaleclueForEx.do'
      await axios.get(url,{
        params:{
          comName:'',
          mobile,
          sources: 'hll-buy-car-pc',
          clueFrom: '拉拉买车官网',
          clueFromCode: 'GW-LLMC',
          realName: name
        }
      })
      this.$message.success('您已经预约成功，请耐心等待销售顾问联系哦！');
      this.ruleForm = {
        name: '',
        mobile: '',
      }
      this.closeDialog()
    },
    // 关闭弹窗
    closeDialog () {
      this.dialogVisible = false
    },
  }
};
</script>
 
<style lang="scss" scoped>
.title-box::before {
  content: "";
  display: block;
  position: absolute;
  background: #f16622;
  width: 85px;
  height: 2px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.title-box {
  position: relative;
  text-align: center;
  height: 66px;
  .title {
    font-size: 30px;
    font-weight: 600;
    color: #2f3439;
    line-height: 66px;
  }
}
.card-square:hover {
  box-shadow: 0px 0px 10px 5px #e3e3e3;
}
.card-square {
  text-align: center;
  height: 225px;
  cursor: pointer;
  transition: all 0.5s linear;
  // box-shadow: #e3e3e3 10px 16px 2px -9px;

  img {
    width: 68px;
    height: 68px;
    margin: 40px 0 10px 0;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #2f3439;
  }
  .p {
    font-size: 12px;
    color: #768191;
  }
}
.content-center {
  width: 1080px;
  margin: 0 auto;
  padding: 10px 50px;
}
.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;
    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}
//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  height: 520px;
  background: url(../assets/banner1.png) no-repeat center;
  background-size: auto 100%;
  position: relative;
  .title-warp {
    width: 500px;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translateY(-50%);
  }
  .title {
    font-size: 44px;
    font-weight: 600;
    color: #ffffff;
    line-height: 66px;
  }
}
.slide-two {
  height: 328px;
  margin: 36px 0 128px;
  background: url(../assets/about_lala_buy.png) no-repeat center;
  background-size: auto 100%;
}
.slide-three {
  margin: 36px 0 128px;
  height: 420px;
  background: url(../assets/carArr.png) no-repeat center;
  background-size: 100% auto;
}
.slide-four {
  margin: 36px 0 128px;
  height: 460px;
  background: url(../assets/pingtai.png) no-repeat center;
  background-size: auto 100%;
  .title-box {
    margin-top: 100px;
  }
}
.slide-five {
  margin: 90px 0 170px;
  height: 148px;
  background: url(../assets/server.png) no-repeat center;
  background-size: 100% auto;

  // background-size: cover;
}
.slide-six {
  margin: 36px 0 128px;
  height: 420px;
  background: url(../assets/pingpai.png) no-repeat center;
  background-size: 100% auto;
}
//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
.send {
  width: 420px;
  input {
    width: 223px;
    height: 36px;
    background: #ffffff;
    border-radius: 2px;
    border: 0;
    padding: 0 20px;
    outline: none;
  }
  > div {
    display: block;
    width: 138px;
    height: 36px;
    background: #f16622;
    border-radius: 2px;
    border-radius: 4px;
    text-align: center;
    line-height: 36px;
    color: #fff;
    font-size: 12px;
    float: right;
    cursor: pointer;
  }
}
/* 弹窗 */
.dialog-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}
.dialog-wrap .dialog-mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}
.dialog-wrap-show,
.dialog-wrap-show .dialog-mask {
  opacity: 1;
  visibility: visible;
}
.dialog-wrap .dialog-form {
  width: 456px;
  // height: 396px;
  padding: 48px 32px;
  background-color: #fff;
  border-radius: 8px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -198px;
  margin-left: -228px;
  transform: scale(1.1);
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}
.dialog-wrap-show .dialog-form {
  transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
}
.dialog-wrap .dialog-form .dialog-close {
  width: 24px;
  height: 24px;
  float: right;
  margin-top: -32px;
  margin-right: -16px;
  cursor: pointer;
  position: relative;
}
.dialog-wrap .dialog-form .dialog-close::before {
  display: block;
  content: "";
  width: 20px;
  height: 2px;
  background-color: #999;
  transform: rotate(45deg);
  position: absolute;
  left: 2px;
  top: 10px;
}
.dialog-wrap .dialog-form .dialog-close::after {
  display: block;
  content: "";
  width: 20px;
  height: 2px;
  background-color: #999;
  transform: rotate(-45deg);
  position: absolute;
  left: 2px;
  top: 10px;
}
.dialog-wrap .dialog-form p {
  margin-bottom: 32px;
}
.dialog-wrap .dialog-form input {
  border-radius: 4px;
  border: 1px solid rgba(220, 222, 226, 1);
  height: 48px;
  line-height: 48px;
  padding: 0 16px;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}
.dialog-wrap .dialog-form p:nth-of-type(1) input,
.dialog-wrap .dialog-form p:nth-of-type(2) input {
  width: 100%;
}
.dialog-wrap .dialog-form p:nth-of-type(3) {
  position: relative;
}
.dialog-wrap .dialog-form p:nth-of-type(3) input {
  width: 100%;
  padding-right: 120px;
}
.dialog-wrap .dialog-form p:nth-of-type(3) span {
  position: absolute;
  right: 0;
  top: 0;
  display: block;
  float: right;
  width: 120px;
  height: 100%;
  text-align: center;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  color: #f16622;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: underline;
}
.dialog-wrap .dialog-form a {
  display: block;
  width: 100%;
  height: 48px;
  line-height: 48px;
  border-radius: 4px;
  text-align: center;
  background-color: #fad1bd;
  color: #fff;
  font-size: 14px;
  margin-top: 44px;
}
</style>